import { useEffect, useMemo } from 'react';

export function useAnalytics() {
  const trackers = useMemo(
    () => [
      {
        trackingId: process.env.REACT_APP_GA_CLIENT_TRACKING_ID,
        gaOptions: {
          name: process.env.REACT_APP_GA_CLIENT_TRACKING_OPTIONS_NAME,
        },
      },
      {
        trackingId: process.env.REACT_APP_GA_ZAPPYRIDE_TRACKING_ID,
        gaOptions: {
          name: process.env.REACT_APP_GA_ZAPPYRIDE_TRACKING_OPTIONS_NAME,
        },
      },
    ],
    [],
  );

  useEffect(() => {
    if (trackers.length) {
      trackers.forEach((tracker) => {
        const scriptId = `gtag-js-${tracker.trackingId}`;
        if (!document.getElementById(scriptId)) {
          const script = document.createElement('script');
          script.async = true;
          script.src = `https://www.googletagmanager.com/gtag/js?id=${tracker.trackingId}`;
          script.id = scriptId;
          document.head.appendChild(script);
        }
      });

      // Initialize dataLayer
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;

      // Initialize GA4
      gtag('js', new Date());

      // Configure trackers
      trackers.forEach((tracker) => {
        gtag('config', tracker.trackingId, {
          name: tracker.gaOptions.name,
        });
      });
    }
  }, [trackers]);

  const GaTracker = {
    trackEvent: (category, action, label, value) => {
      try {
        if (trackers.length && window.gtag) {
          trackers.forEach((tracker) => {
            window.gtag('event', action, {
              event_category: category,
              event_label: label,
              value: value,
              send_to: tracker.trackingId,
            });
          });
        }
      } catch (error) {
        console.error('Failed to track event:', error);
      }
    },

    pageview: (location) => {
      if (!location) return;

      const page = location.pathname + location.search;

      if (trackers.length && window.gtag) {
        trackers.forEach((tracker) => {
          window.gtag('event', 'page_view', {
            page_location: page,
            send_to: tracker.trackingId,
          });
        });
      }
    },
  };

  return {
    GaTracker,
  };
}
